export default "<app-header class=\"acx\"></app-header>\r\n<router-outlet></router-outlet>\r\n<app-footer></app-footer>"